/* eslint-disable react/no-array-index-key, react/no-unknown-property */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  tabNav: {
    '& ul': {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      backgroundColor: theme.colors.white,
      borderBottom: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      listStyle: 'none',
      padding: 0,
      marginBottom: 0,
      '& li': {
        display: 'flex',
        alignItems: 'center',
        height: '44px',
        padding: '14px 10px',
        color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
        fontWeight: 500,
        fontSize: '14px',
        textDecoration: 'none',
        cursor: 'pointer',
        borderBottom: '2px solid transparent',
        '&:hover': {
          borderBottom: `2px solid ${`var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`}`,
        },
      },
      '& .active': {
        color: `var(--gameday-body-textColorDark, ${theme.body.textColorDark})`,
        borderBottom: `2px solid ${`var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`}`,
        fontWeight: '500',
        '& .tab-num': {
          backgroundColor: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
          color: theme.colors.white,
          borderColor: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
        },
      },
    },
    '&.mainTabs': {
      backgroundColor: 'transparent',
      borderBottom: 0,
      margin: 0,
      '& ul': {
        margin: 0,
        background: 'transparent',
        borderBottom: 0,
      },
      '& li': {
        borderBottom: 0,
        lineHeight: '16px',
        padding: '16px',
        borderTop: '2px solid transparent',
        '&:hover': {
          borderBottom: '0',
          color: `var(--gameday-body-textColorDark, ${theme.body.textColorDark})`,
        },
      },
      '& .active': {
        borderBottom: 0,
        borderTop: `2px solid ${`var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`}`,
        backgroundColor: theme.colors.white,
      },
    },
    '&.subTabs': {
      '& ul': {
        borderBottom: 0,
        marginTop: 0,
      },
      '& li': {
        border: `1px solid ${theme.tabs.tabBorderColor}`,
        fontSize: '0.875rem',
        padding: '8px 14px',
        borderRightWidth: 0,
        backgroundColor: `var(--gameday-tabs-tabBackgroundColor, ${theme.tabs.tabBackgroundColor})`,
        fontWeight: '400',
        '&:first-child': {
          borderRadius: '4px 0 0 4px',
          '&:last-child': {
            borderRadius: '4px',
            borderRightWidth: '1px',
          },
        },
        '&:last-child': {
          borderRadius: '0 4px 4px 0',
          borderRightWidth: '1px',
        },
        '&:hover': {
          color: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
          borderBottom: `1px solid ${`var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`}`,
          fontWeight: '500',
        },
        '&.active': {
          borderBottom: `1px solid ${theme.tabs.tabBorderColor}`,
          color: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
          backgroundColor: `var(--gameday-tabs-tabActiveBackgroundColor, ${theme.tabs.tabActiveBackgroundColor})`,
        },
      },
    },
    '& .disabled': {
      pointerEvents: 'none', // This makes it not clickable
      opacity: '0.6', // This grays it out to look disabled
    },
  },
  tabNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    marginRight: '5px',
    border: `1px solid ${`var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`}`,
    borderRadius: '10px',
    fontSize: theme.typography.fontSizeTinyish,
  },
})

const TabNavigator = ({ tabs, activeTab, onChangeTab, classes, mainTabs, subTabs, withNumbers }) => (
  <div className={cn(classes.tabNav, { subTabs }, { mainTabs })}>
    <ul>
      {tabs.map(
        (tab, key) =>
          tab.show && (
            // biome-ignore lint/a11y/noStaticElementInteractions: TODO
            <li
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              key={key}
              role="presentation"
              onClick={() => onChangeTab(tab.value)}
              aria-label={tab.value}
              disable
              className={
                // eslint-disable-next-line no-nested-ternary
                activeTab === tab.value ? (tab.disable ? cn('disabled') : 'active') : tab.disable ? cn('disabled') : ''
              }
            >
              {withNumbers && <span className={cn(classes.tabNumber, 'tab-num')}>{tab.value}</span>}
              {tab.title}
            </li>
          )
      )}
    </ul>
  </div>
)

TabNavigator.defaultProps = {
  tabs: [],
  activeTab: '',
  onChangeTab: () => {},
  subTabs: false,
  mainTabs: false,
  withNumbers: false,
}

const TabComponent = withStyles(styles)(TabNavigator)
TabComponent.displayName = 'TabNavigator'
export default TabComponent
